export default __webpack_public_path__ + "static/media/projects.e37e2172.svg";